import React from 'react'
import { FlexDiv } from '../../../components'
import { CheckCircle, ErrorOutline } from '@mui/icons-material'
import { PasswordRequirementResult } from './passwordValidator'

interface Props {
    passwordRequirementResult: PasswordRequirementResult
    containerStyle?: React.CSSProperties
}

export const PasswordRequirements = (props: Props) => {
    const { passwordRequirementResult, containerStyle } = props

    return (
        <FlexDiv
            style={{
                flexDirection: 'column',
                ...containerStyle,
            }}
        >
            <Requirement
                valid={passwordRequirementResult.lengthValid}
                text="At least 14 characters"
            />
            <Requirement
                valid={passwordRequirementResult.lowerCaseValid}
                text="At least 1 lower case letter"
            />
            <Requirement
                valid={passwordRequirementResult.upperCaseValid}
                text="At least 1 upper case letter"
            />
            <Requirement
                valid={passwordRequirementResult.numberValid}
                text="At least 1 number"
            />
            <Requirement
                valid={passwordRequirementResult.passwordsMatch}
                text="Passwords must match"
            />
        </FlexDiv>
    )
}

interface RequirementProps {
    text: string
    valid: boolean
}

const Requirement = (props: RequirementProps) => {
    return (
        <FlexDiv style={{ marginBottom: 4 }}>
            {props.valid ? (
                <CheckCircle fontSize="small" color="primary" />
            ) : (
                <ErrorOutline fontSize="small" />
            )}
            <span style={{ marginLeft: 2 }}>{props.text}</span>
        </FlexDiv>
    )
}
